import { Construction } from "lucide-react";

const NOTE = {
  "OPS-1B": "The digital FRS lands here: Original vs Current, revision log, and the same record Field Operations works from.",
  "OPS-2": "Budget generation from the working estimate, commitments and budget health.",
  "OPS-3": "Change orders — Draft › Submitted › Rejected | Approved › Executed. Executed is when it hits the budget.",
  "OPS-4": "Submittals, generated from the Reconciled FRS, with the spec-vs-FRS discrepancy check.",
  "OPS-5": "Purchase orders by manufacturer + cost code, with the Combine action and the readiness traffic light.",
  "OPS-6": "Schedule of values, progress billing and retention.",
  "OPS-8": "Insurance, licences and certified payroll, with expiry tracking off the document library.",
  "OPS-10": "Closeout package: warranties, as-builts, O&M and final billing.",
};

export default function Placeholder({ tab }) {
  if (!tab) return null;
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-slate-300 bg-slate-50/60 px-6 py-16 text-center"
         data-testid={`ops-placeholder-${tab.key}`}>
      <Construction className="h-7 w-7 text-slate-300" />
      <div>
        <p className="text-sm font-semibold text-slate-700">{tab.label}</p>
        <p className="mt-1 max-w-md text-xs text-slate-500">
          {NOTE[tab.cluster] || "Delivered by a later cluster."}
        </p>
      </div>
      {tab.cluster && (
        <span className="rounded-full border border-slate-200 bg-white px-2 py-0.5 text-[11px] font-medium text-slate-500">
          {tab.cluster}
        </span>
      )}
    </div>
  );
}
